import React, { useEffect, useState } from "react";
import {
	IonButton,
	IonCol,
	IonIcon,
	IonImg,
	IonLabel,
	IonRow,
	IonRadio,
	IonRadioGroup,
	IonAlert,
	IonModal,
	IonItem,
	IonTextarea,
	isPlatform,
} from "@ionic/react";
import Header from "../../../utils/Header";
import "../../../global.scss";
import "../Confirmation/confirm.scss";
import "../Cart/cart.scss";
// import {CONFIRMATION,MY_CART,CITY_4334} from "../../../constants";
import * as constants from "../../../constants";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { connect } from "react-redux";
import {
	getTimeSlots,
	saveBookingTransaction,
	saveReservations,
	updateOnBoarding,
	uploadBookingImage,
	signIn,
	modifyToken,
	savePrebookingImage,
	// saveVehicleBookingImage,
	deletePrebookingImage,
	saveLocationPermissionStatus,
	// razorpayCallBack,
	getCartItemsList,
	saveBookingDetailsHeaderStatus,
} from "../../../Store/Actions";
import ConfirmPageHeading from "../../CustomComponents/confirmHeader";
import moment from "moment";
import UserAddressModal from "../../../utils/UserAddressModal";
import { ToastMessage } from "../../../utils/toastMessage";
import { AlertMessage } from "../../../utils/alertMessage";
import AddNewAddress from "../../Portal/addNewAddress";
import { checkForPlural, checkMediaQuery } from "../../../utils";
import LoginInCart from "../Cart/loginInCart";
import OtpInCart from "../Cart/otpInCart";
import { leaveAnimation } from "../Cart/cart";
import { Camera, CameraOptions } from "@ionic-native/camera";
import { CustomIonImage } from "../../CustomComponents/IonImg";
// import "capacitor-razorpay";
// import { Plugins } from "@capacitor/core";
import { knowLocationPermission } from "../myAddresses";
import { COLLECTIONS, updateDoc, uploadImageToFireStorage } from "../../../firebase";

const options: CameraOptions = {
	destinationType: Camera.DestinationType.DATA_URL,
	sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM,
	encodingType: Camera.EncodingType.JPEG,
};
// const { Checkout } = Plugins;

const ConfirmScreen: React.FC = (props: any) => {
	const [showCalendar, setShowCalendar] = useState(false);
	const [login, setLogin] = useState(false);
	const [showOtp, setShowOtp] = useState(false);
	const [pickUpNotes, setPickUpNotes] = useState("");
	const [serviceNotes, setServiceNotes] = useState("");
	const [show_acc, setAccordian] = useState(false);
	const [show_service_acc, setServiceAccordian] = useState(false);
	const [date, setDate] = useState(new Date());
	const [slot, setTimeSlot] = useState("");
	const [dateTemp, setDateTemp] = useState(new Date());
	const [slotTemp, setTimeSlotTemp] = useState("");
	const [dateSelected, setDateSelected] = useState(false);
	const [showSlotModal, setShowSlotModal] = useState(false);
	const [myLocation, setLocation] = useState("1");
	const [showAlert, setShowAlert] = useState(false);
	const [pickup, setPickup] = useState("");
	const [dropLocation, setDropLoc] = useState("");
	const [showAddModal, setShowAddModal] = useState(false);
	const [showMap, setShowMap] = useState(false);
	const [pickOtherAdd, setPickOtherAdd] = useState([]);
	const [address_label, addLabel] = useState("");
	const [other_add, setAddress] = useState([]);
	const [user_add, setUserAddress] = useState([]);
	const [allImages, setAllImages] = useState<File[]>([]);
	const [allImagesToUpload, setAllImagesToUpload] = useState<File[]>([]);
	const [time_arr, setTimeArray] = useState([]);
	const [servPart, setServPart] = useState([]);
	const [orderId, setOrderId] = useState("");
	const [bookingId, setBookingId] = useState("");

	const [vehicleRegistrationNumber, setVehicleRegistrationNumber] = useState("");
	const [toast, setToast] = React.useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});
	const [changeAddress, setChangeAddress] = React.useState(false);
	const days = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
	const months = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"June",
		"July",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	];

	// React.useEffect(() => {
	//   console.log("ABC");
	//   console.log("PROPS =======", props);

	//   if (!!allImagesToUpload) {
	//     if (allImagesToUpload.length > 0) {
	//       uploadImageToFirebase();
	//     } else {
	//       handleBooking(orderId, bookingId);
	//     }
	//   }
	// }, [props.booking_image]);

	React.useEffect(() => {
		[
			{ value: other_add, callBack: (value: any) => setAddress(value) },
			{ value: pickOtherAdd, callBack: (value: any) => setPickOtherAdd(value) },
			{ value: user_add, callBack: (value: any) => setUserAddress(value) },
		].map((ele: any) => {
			if (ele.value.length) {
				const addressDetails: any = ele.value[0];
				checkIfAddressExists(
					addressDetails.addressType,
					addressDetails.latitude,
					addressDetails.longitude
				)
					? ele.callBack(ele.value)
					: ele.callBack([]);
			}
		});
	}, [props.userAddressList]);

	React.useEffect(() => {
		(async function () {
			if (props.userVehiclesList.length && props.sliderCatelogVehicleId) {
				const registrationNumberList = props.userVehiclesList.filter(
					(ele: any) => ele.catalogVehicleId === props.sliderCatelogVehicleId
				);
				setVehicleRegistrationNumber(registrationNumberList[0].registrationNumber);
			}
		})();
	}, [props.userVehiclesList, props.sliderCatelogVehicleId]);

	const checkIfAddressExists = (addressType: string, lat: string, long: string) => {
		return props.userAddressList.find(
			(ele: any) =>
				ele.addressType === addressType && ele.latitude === lat && ele.longitude === long
		);
	};

	const addressString = (item: any) => {
		const address_string = !!item
			? item.map((ele: any) => {
					return `${
						ele.addressline1.slice(0, 1).toUpperCase() + ele.addressline1.slice(1)
					},
        ${ele.landmark.slice(0, 1).toUpperCase() + ele.landmark.slice(1)},
        ${ele.city.slice(0, 1).toUpperCase() + ele.city.slice(1)},
        ${ele.postalCode},
        ${ele.country.slice(0, 1).toUpperCase() + ele.country.slice(1)}`;
			  })
			: "";

		return address_string;
	};

	const DisplayName = (item: any) => {
		const name = !!item
			? item.map((ele: any) => {
					return ele.addressType;
			  })
			: "";
		return name;
	};

	const HomeAdd = () => {
		const home_arr = props.userAddressList.filter(
			(ele: any) =>
				(props.defaultAddressRef || props.selectedAddressRef || "").split("/").pop() ===
				ele.did
		);
		return addressString(home_arr);
	};

	React.useEffect(() => {
		// console.log("PROPS ..... ==== ", props);
		// console.log("Time date received", props.time_slots);

		var currDate: Date = new Date();
		// currDate.setHours(0, 0, 0, 0);

		let timeSlotCheckIsRequired = false;
		// if (dateTemp.getTime() === currDate.getTime()) {
		//   console.log("Selected date is same date");
		//   timeSlotCheckIsRequired = true;
		// } else if (dateTemp.getTime() < currDate.getTime()) {
		//   console.log("Selected date is lower date");
		//   setToast({
		//     showToast: true,
		//     toastMessage: "Invalid date",
		//     severity: "warning",
		//   });
		//   setTimeArray([]);
		//   return;
		// } else {
		//   console.log("Selected date is higher date");
		// }

		let curDt: Date = new Date(currDate);
		curDt.setHours(0, 0, 0, 0);

		let tempDt: Date = new Date(dateTemp);
		tempDt.setHours(0, 0, 0, 0);

		console.log("Date === ", dateTemp > currDate);

		if (tempDt >= curDt) {
			console.log("Selected date is same date ..... 0");
			timeSlotCheckIsRequired = true;
		} else {
			// setToast({
			// 	showToast: true,
			// 	toastMessage: "Invalid date",
			// 	severity: "warning",
			// });
			setTimeArray([]);
			return;
		}

		let timeDt = dateTemp;

		if (timeSlotCheckIsRequired) {
			const timeArr = props.time_slots.filter((ele: any) => {
				timeDt.setHours(parseInt(ele.startTime.split(":")[0]));
				return timeDt > currDate;
			});
			console.log("timeDt =======", timeDt);
			console.log("currDate =======", currDate);
			console.log("timeArr =======", timeArr);
			setTimeArray(timeArr);
		} else {
			setTimeArray(props.time_slots);
		}
	}, [props.time_slots]);

	const changeDate = (d: any) => {
		// setDate(d);
		// setTimeSlot("");
		setDateTemp(d);
		setTimeSlotTemp("");
		var dateFormat = moment(new Date(d)).format("DD/MM/YYYY");

		let fDate = new Date();
		let lDate = new Date();

		if (props.firstAvailable.length > 0) {
			fDate = new Date(props.firstAvailable);
			lDate = new Date(props.lastAvailable);
		}

		fDate.setHours(0, 0, 0, 0);
		lDate.setHours(0, 0, 0, 0);

		// if (d >= new Date(props.firstAvailable) && d <= new Date(props.lastAvailable)) {
		if (d.getTime() >= fDate.getTime()) {
			// && d.getTime() <= lDate.getTime()) {
			props.getTimeSlots(dateFormat, props.workshopId);
		}

		setDateSelected(true);
		setShowCalendar(false);
		setShowSlotModal(true);
	};

	const changeTimeSlot = (slot: any) => {
		// setTimeSlot(slot);
		setTimeSlotTemp(slot);
	};

	// const showTimeSlotPopup = () => {
	//   console.log("Show Time Slot");
	//   setDateSelected(true);
	//   // setShowCalendar(false);

	//   if (
	//     dateTemp.getTime() >= new Date(props.firstAvailable).getTime() &&
	//     dateTemp.getTime() <= new Date(props.lastAvailable).getTime()
	//   ) {
	//     if (!!time_arr && time_arr.length === 0) {
	//       var dateFormat = moment(new Date(dateTemp)).format("DD/MM/YYYY");
	//       props.getTimeSlots(dateFormat, props.workshopId);
	//     } else if (!!time_arr && time_arr.length > 0) {
	//       setShowCalendar(false);
	//       setShowSlotModal(true);
	//     }
	//   }
	// };

	const handleMap = async (key: any) => {
		addLabel(key);
		// if ((await knowLocationPermission({ ...props })) === constants.DENIED) {
		//   setShowMap(true);
		// } else {
		//   setShowAddModal(true);
		// }

		setShowAddModal(true);
	};

	const default_add = props.userAddressList.filter(
		(ele: any) =>
			(props.defaultAddressRef || props.selectedAddressRef || "").split("/").pop() ===
			ele.did
	);

	const vehicle_id = props.userVehiclesList.filter(
		(ele: any) => (props.selectedVehicleRef || "").split("/").pop() === ele.did
	);

	const handlePaynow = async () => {
		try {
			const default_address = props.userAddressList.filter(
				(ele: any) => (props.selectedAddressRef || "").split("/").pop() === ele.did
			);
			const pick = pickup === "pick_default" ? default_address[0] : pickOtherAdd[0];
			const drop = dropLocation == "drop_default" ? pick : other_add[0];
			const address = !!user_add.length ? user_add[0] : default_address[0];
			if (!pick && myLocation === "1") {
				throw Error("Please select Pickup location");
			}
			if (myLocation === "2" && !address) {
				throw Error("Please select your location");
			}
			if (!drop && myLocation === "1") {
				throw Error("Please select Drop location");
			}
			if (!slot) {
				throw Error("Please select Date and Time slot");
			}
			if (props.hasOwnProperty("isAnonymous") && props.isAnonymous) {
				setLogin(true);
				return;
			}
			const pickUpFromMyLocation = {
				pickupLocation: Object.keys(pick || {}).length
					? {
							profileLocationName: pick.addressType || "", //"Home",
							latitude: pick.latitude || "", //"123.456",
							longitude: pick.longitude || "", // "234.567",
					  }
					: {},
				dropoffLocation: Object.keys(drop || {}).length
					? {
							profileLocationName: drop.addressType || "", //"Home",
							latitude: drop.latitude || "", //"123.456",
							longitude: drop.longitude || "", //"234.567",
					  }
					: {},
			};
			const dropAtNearGarage = {
				pickupLocation: Object.keys(address || {}).length
					? {
							profileLocationName: address.addressType || "",
							latitude: address.latitude || "",
							longitude: address.longitude || "",
					  }
					: {},
				dropoffLocation: Object.keys(address || {}).length
					? {
							profileLocationName: address.addressType || "",
							latitude: address.latitude || "",
							longitude: address.longitude || "",
					  }
					: {},
			};
			let vehicleRegNo = "";
			let workshopId = "";
			let serviceNames = "";
			if (props.userVehiclesList.length && props.sliderCatelogVehicleId) {
				const registrationNumberList = props.userVehiclesList.filter(
					(ele: any) => ele.catalogVehicleId === props.sliderCatelogVehicleId
				);
				vehicleRegNo = registrationNumberList[0].registrationNumber;
			}
			workshopId = !!props.cart_items[0].workshopId ? props.cart_items[0].workshopId : "";
			if (props.service_data.length) {
				serviceNames = props.service_data.map((ele: any) => ele.displayName).join(",");
			}

			// const sParts: any;

			props.cart_items.map((ele: any) => {
				// console.log("PARTS cart sId ======= ", ele.serviceId);

				const arr = props.service_data_value.filter(
					(sItem: any) =>
						ele.serviceId === sItem.service.serviceId &&
						sItem.service.parts &&
						sItem.service.parts.length > 0
				);
				if (arr.length > 0) {
					// console.log("PARTS ind found ======= ", arr[0].service.parts);
					setServPart(arr[0].service.parts);
					// props.cart_items[0].parts = arr[0].service.parts;
					ele.parts = arr[0].service.parts;
				}
				// else {
				//   ele.parts = [];
				// }
			});

			// props.cart_items[0].parts = servPart;

			// console.log("PARTS Found ======= ", servPart);
			// console.log("props.cart_items ==== ", props.cart_items);

			// console.log(
			//   "UTC Now with Time === ",
			//   moment(moment(new Date(date)).format("YYYY-MM-DD") + "T" + slot.split("-")[0] + ":00"),
			// );
			// console.log(
			//   "UTC Now with Time UTC === ",
			//   moment.utc(moment(new Date(date)).format("YYYY-MM-DD") + "T" + slot.split("-")[0] + ":00"),
			// );

			// console.log(
			//   "UTC Now with Date Time STRING === ",
			//   moment(new Date(date)).format("YYYY-MM-DD") + "T" + slot.split("-")[0] + ":00",
			// );

			let startUTCTime = moment.utc(
				new Date(
					moment(new Date(date)).format("YYYY-MM-DD") + "T" + slot.split("-")[0] + ":00"
				)
			);

			// console.log("UTC Start Time ISO ==== ", startUTCTime.toISOString());

			let endUTCTime = moment.utc(
				new Date(
					moment(new Date(date)).format("YYYY-MM-DD") + "T" + slot.split("-")[1] + ":00"
				)
			);
			// console.log("UTC End Time ==== ", endUTCTime.toISOString());

			// console.log("PROPS ..... ==== ", props);

			const mobileNo = props.mobileNumber || props.primaryPhoneNumber;

			// * Booking Payload
			const updatedPayload = {
				userVehicleId: vehicle_id[0].catalogVehicleId,
				customerName: props.name || "",
				vehicleNumber: vehicleRegNo || "",
				mobileNumber: constants.COUNTRY_CODE_PREFIX + " " + mobileNo,
				items: props.cart_items,
				isPickupRequired: myLocation === "1" ? true : false,
				pickupDropoffData: {
					pickupLocation:
						myLocation === "1"
							? pickUpFromMyLocation.pickupLocation
							: dropAtNearGarage.pickupLocation,
					dropoffLocation:
						myLocation === "1"
							? pickUpFromMyLocation.dropoffLocation
							: dropAtNearGarage.dropoffLocation,
					pickupOrDropoffNotes: !!pickUpNotes ? pickUpNotes : "",
					pickupDate: moment(new Date(date)).format("YYYY-MM-DD"),
					// myLocation === "1" ? moment(new Date(date)).format("YYYY-MM-DD") : "",
					pickupSlot:
						// myLocation === "1"
						// 	?
						{
							startTime: !!slot.split("-")[0] ? slot.split("-")[0] : "",
							endTime: !!slot.split("-")[1] ? slot.split("-")[1] : "",
						},
					// : {},
				},
				startTime: startUTCTime.toISOString(), // myLocation === "1" ? startUTCTime.toISOString() : "",
				endTime: endUTCTime.toISOString(), // myLocation === "1" ? endUTCTime.toISOString() : "",
				notes: !!serviceNotes ? serviceNotes : "",
				catalogVehicleId: vehicle_id[0].catalogVehicleId,
				variant: vehicle_id[0].variant, // "S DRIVE 18i",
				year: vehicle_id[0].year,
			};

			// console.log("updatedPayload ===", updatedPayload);

			// * Reservation Payload
			// const reservationpayload = {
			//   workshopId: parseInt(workshopId) || "",
			//   customerName: props.name || "",
			//   vehicleNumber: vehicleRegNo || "",
			//   emailAddress: props.email || "",
			//   startTime:
			//     myLocation === "1"
			//       ? moment(
			//           new Date(date).setHours(
			//             !!slot.split("-")[0] ? parseInt(slot.split("-")[0]) : 0,
			//             0,
			//             0,
			//           ),
			//         )
			//       : "",
			//   endTime:
			//     myLocation === "1"
			//       ? moment(
			//           new Date(date).setHours(
			//             !!slot.split("-")[0] ? parseInt(slot.split("-")[1]) : 0,
			//             0,
			//             0,
			//           ),
			//         )
			//       : "",
			//   reservationType: "ServiceAppointment",
			//   service: serviceNames || "",
			//   mobileNumber: props.mobileNumber || "",
			//   bay: "",
			//   status: "booked",
			//   createdFrom: "B2C",
			// };

			// console.log(props.mobileNumber + " .... PHONE NUMBER ====", updatedPayload);

			// *************************
			// Calling Booking API
			const res = await props.saveBookingTransaction(updatedPayload);

			if (!!res && res.status === "SUCCESS") {
				const { data = [] } = res;

				localStorage.removeItem("workshopId");
				setOrderId(data[0].orderId);
				setBookingId(data[0].bookingId);

				setTimeout(function () {
					// Fire deviceready on listeners that were registered before cordova.js was loaded.
					// console.log("BOOK RESP .... Inside Time out ===");
					handleBooking(data[0].orderId, data[0].bookingId);
				}, 3000);

				// console.log("BOOK RESP .... Outside Time out ===");
				// if (allImages.length > 0) {
				await uploadAllImages(data[0].bookingId);
				// } else {
				//   console.log("BOOK RESP .... Inside Time out ===");
				//   await handleBooking(data[0].orderId, data[0].bookingId);
				// }
			}

			// *************************
		} catch (e: any) {
			setToast({
				showToast: true,
				toastMessage: e.message,
				severity: "warning",
			});
		}
	};

	const uploadAllImages = async (appointmentId: any) => {
		try {
			for (let i = 0; i < allImagesToUpload.length; i++) {
				const fd = new FormData();
				fd.append("file", allImagesToUpload[i]); //convertedFile);
				// console.log("1........ uploading image # " + i);
				const imgRes = await props.uploadBookingImage(appointmentId, fd);
				// console.log("2........ image # " + i + " uploaded");
			}

			// const fdata = new FormData();
			// for (let i = 0; i < allImagesToUpload.length; i++) {
			//   console.log("3........ adding image # " + i);
			//   fdata.append("file", allImagesToUpload[i]); //convertedFile);
			// }

			// console.log("4........ Uploading all " + allImagesToUpload.length);
			// fdata.append("appointmentId", appointmentId);
			// const res = await props.saveVehicleBookingImage(fdata);
			// console.log("5........");
		} catch (error: any) {
			// console.log("IMG Error ====", JSON.stringify(error));
			setToast({
				showToast: true,
				toastMessage: error.message,
				severity: "warning",
			});
		}
	};

	const uploadImage = async (event: any) => {
		try {
			const file = event.target.files[0];
			if (["image/png", "image/jpg", "image/jpeg"].includes(file.type)) {
				event.preventDefault();
				const base64Image: any = await toBase64(event.target.files[0]);
				const convertedFIle: any = await imageConversion(base64Image);
				setAllImages([...allImages, base64Image]); //convertedFIle]);
				setAllImagesToUpload([...allImagesToUpload, convertedFIle]);
				return ""; //res;
			} else {
				throw Error("Please upload valid format");
			}
		} catch (error: any) {
			setToast({
				showToast: true,
				toastMessage: error.message,
				severity: "warning",
			});
		}
	};

	const deleteImage = async (imgUrl: any) => {
		// await props.deletePrebookingImage(imgUrl, vehicle_id[0].catalogVehicleId);

		var array = [...allImages]; // make a separate copy of the array
		var index = array.indexOf(imgUrl);
		if (index !== -1) {
			array.splice(index, 1);
			setAllImages(array);
		}
	};

	const AccessNativeCamera = async () => {
		Camera.getPicture(options).then(
			async (imageData) => {
				const base64String: any = "data:image/jpeg;base64," + imageData;
				setAllImages([...allImages, base64String]);
				const file: any = await imageConversion(base64String);
				setAllImagesToUpload([...allImagesToUpload, file.name[0]]);
			},
			(err: any) => {
				console.error(err, "CamError");
			}
		);
	};

	const toBase64 = (file: any) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
		});

	const imageConversion = (imageData: any) => {
		return fetch(imageData)
			.then((res) => res.blob())
			.then(async (blob) => {
				const b: any = blob;
				b.lastModifedDate = new Date();
				b.name = new Date().getTime() + ".jpeg";
				const file = new File([b], "image.png", { type: "image/png" });
				return file;
			});
	};
	// const handleRazorpay = async (ordId: any, bookingId: any) => {
	// 	var options = {
	// 		description: "Autorox",
	// 		image: null,
	// 		currency: "AED",
	// 		key: "rzp_test_QlO86Kqf8WsYlD",
	// 		amount:
	// 			Number(props.cart_estimates.advancePayment) > 0
	// 				? String(Number(props.cart_estimates.advancePayment) * 100)
	// 				: String(
	// 						(Number(props.cart_estimates.totalEstimated) -
	// 							Number(props.cart_estimates.discount)) *
	// 							100
	// 				  ),
	// 		name: "autorox",
	// 		order_id: ordId,
	// 		prefill: {
	// 			email: props.email,
	// 			contact: props.primaryPhoneNumber,
	// 			name: props.name,
	// 		},
	// 		theme: { color: "red" },
	// 		// callback_url:
	// 		//   "https://b2c-api-dev.autorox.co:8443/b2c/api/transaction/payment/callback",
	// 		// redirect: true,
	// 		// modal: {
	// 		//   ondismiss: function () {
	// 		//     props.getCartItemsList();
	// 		//     props.saveBookingDetailsHeaderStatus(true);
	// 		//     props.closeModal();
	// 		//     props.history.push({
	// 		//       pathname: "/portal/booking_details",
	// 		//       state: { idOfBooking: bookingId },
	// 		//     });
	// 		//   },
	// 		// },
	// 		retry: false,
	// 	};

	// 	await Checkout.open(options)
	// 		.then((sucRes: any) => {
	// 			const { response = {} } = sucRes;
	// 			props.razorpayCallBack(
	// 				true,
	// 				"",
	// 				"",
	// 				"",
	// 				"",
	// 				bookingId,
	// 				response.razorpay_order_id,
	// 				response.razorpay_payment_id,
	// 				response.razorpay_signature
	// 			);
	// 			props.getCartItemsList();
	// 			const userDoc = {
	// 				settings: { ...props.settings, workshopId: "" },
	// 			};
	// 			updateDoc(props.uid, userDoc, COLLECTIONS.USERS);
	// 			props.closeModal();
	// 			props.saveBookingDetailsHeaderStatus(true);
	// 			props.history.push({
	// 				pathname: "/portal/booking_details",
	// 				state: { idOfBooking: bookingId },
	// 			});
	// 		})
	// 		.catch((failRes: any) => {
	// 			const parsedError = typeof failRes === "string" ? JSON.parse(failRes) : failRes;
	// 			props.razorpayCallBack(
	// 				false,
	// 				parsedError.code + "",
	// 				parsedError.description,
	// 				"",
	// 				"",
	// 				bookingId,
	// 				"",
	// 				"",
	// 				""
	// 			);
	// 			props.getCartItemsList();
	// 			const userDoc = {
	// 				settings: { ...props.settings, workshopId: "" },
	// 			};
	// 			updateDoc(props.uid, userDoc, COLLECTIONS.USERS);
	// 			props.saveBookingDetailsHeaderStatus(true);
	// 			props.closeModal();
	// 			props.history.push({
	// 				pathname: "/portal/booking_details",
	// 				state: {
	// 					idOfBooking: bookingId,
	// 				},
	// 			});
	// 		});
	// };

	const handleBooking = async (ordId: any, bookingId: any) => {
		var options = {
			description: "Autorox",
			image: null,
			currency: "ADE",
			key: "rzp_test_QlO86Kqf8WsYlD",
			amount:
				Number(props.cart_estimates.advancePayment) > 0
					? String(Number(props.cart_estimates.advancePayment) * 100)
					: String(
							(Number(props.cart_estimates.totalEstimated) -
								Number(props.cart_estimates.discount)) *
								100
					  ),
			name: "autorox",
			order_id: "",
			prefill: {
				email: props.email,
				contact: props.primaryPhoneNumber,
				name: props.name,
			},
			theme: { color: "red" },
			// callback_url:
			//   "https://b2c-api-dev.autorox.co:8443/b2c/api/transaction/payment/callback",
			// redirect: true,
			// modal: {
			//   ondismiss: function () {
			//     props.getCartItemsList();
			//     props.saveBookingDetailsHeaderStatus(true);
			//     props.closeModal();
			//     props.history.push({
			//       pathname: "/portal/booking_details",
			//       state: { idOfBooking: bookingId },
			//     });
			//   },
			// },
			retry: false,
		};

		try {
			// props.razorpayCallBack(
			//   true,
			//   "",
			//   "",
			//   "",
			//   "",
			//   bookingId,
			//   response.razorpay_order_id,
			//   response.razorpay_payment_id,
			//   response.razorpay_signature
			// );
			props.getCartItemsList();
			const userDoc = {
				settings: { ...props.settings, workshopId: "" },
			};
			updateDoc(props.uid, userDoc, COLLECTIONS.USERS);
			props.closeModal();
			props.saveBookingDetailsHeaderStatus(true);
			props.history.push({
				pathname: "/portal/booking_details",
				state: { idOfBooking: bookingId },
			});
		} catch (error: any) {
			const parsedError = error.message;
			// props.razorpayCallBack(
			//   false,
			//   parsedError.code + "",
			//   parsedError.description,
			//   "",
			//   "",
			//   bookingId,
			//   "",
			//   "",
			//   ""
			// );
			props.getCartItemsList();
			const userDoc = {
				settings: { ...props.settings, workshopId: "" },
			};
			updateDoc(props.uid, userDoc, COLLECTIONS.USERS);
			props.saveBookingDetailsHeaderStatus(true);
			props.closeModal();
			props.history.push({
				pathname: "/portal/booking_details",
				state: {
					idOfBooking: bookingId,
				},
			});
		}
	};

	const enterAnimation = (baseEl: any) => {
		return leaveAnimation(baseEl).direction("reverse");
	};

	const handleMapOpen = (key: any) => {
		// if (!!props.globalSettings.length) {
		// const workshopListingModel = props.globalSettings[0].workshopListingModel;
		// if (workshopListingModel !== "Segment") {
		//   setChangeAddress(true);
		// } else {
		handleMap(key);
		// }
		// }
	};

	return (
		<IonCol className="confirm_parent pd_0 ">
			<div
				className="personal_details_text confirmation_header margin-bottom wholeApp"
				style={{
					paddingTop:
						isPlatform("android") || isPlatform("mobileweb")
							? 20
							: isPlatform("ios")
							? 0
							: 59,
				}}
			>
				<ConfirmPageHeading
					mainHeader={constants.CONFIRMATION}
					navigation={props}
					onClick={
						() => props.closeModal()
						// props.showModal ? props.closeModal() : props.history.goBack()
					}
					showCars={true}
					customStyle={{
						position: "relative",
						backgroundColor: isPlatform("desktop") ? "#ffffff" : "#f5f5f5",
						zIndex: 999,
						paddingBottom: isPlatform("ios") ? 20 : 0,
					}}
				/>
			</div>

			<div
				className="body_scroll-confirm"
				style={{ marginTop: isPlatform("ios") ? 25 : 5 }}
			>
				{props.service_data.map((ele: any, ind: number) => (
					<div className="card_style background-white right_align" key={ind}>
						<div className="confirm_img_div">
							<img
								// src={ele.imageUrl}
								src={!!ele.imageUrl ? ele.imageUrl : "/images/brake_image.svg"}
								className="rec_ser_image"
							/>
							<div className="rec_row_wrap">
								<div className="tag_desc">
									<IonLabel className="rec_ser_problem">{ele.displayName}</IonLabel>
									<IonLabel className="rec_ser_sub">{ele.shortDescription}</IonLabel>
									{!!ele.addOnsSelected &&
										ele.addOnsSelected.length > 0 &&
										ele.addOnsSelected.some((x: any) => !!x.addOnId) && (
											<IonLabel className="addon_lable">
												Addon :
												<div className="addon_div">
													{ele.addOnsSelected
														.map((ele: any) => ele.displayName)
														.slice(0, 1)
														.join(",")}
												</div>
											</IonLabel>
										)}
								</div>
							</div>
							<div className="confirm_tag_desc">
								<IonLabel
									className="rec_ser_sub cost_estimated"
									style={{
										whiteSpace: "nowrap",
									}}
								>
									{constants.ESTIMATED_COST}
								</IonLabel>
								<IonLabel className="estimated_cost_val roboto">
									{constants.RupeeSymbol} {Number(ele.defaultPrice)}
									{/* {Number(props.cart_estimates.totalEstimated) -
                    Number(props.cart_estimates.discount)} */}
								</IonLabel>
							</div>
						</div>
					</div>
				))}

				{[
					{ text: "Pickup from my location", id: "1" },
					{ text: "I will Drop at nearby garage", id: "2" },
				].map((ele: any, index: number) => (
					<div
						key={index}
						className={`btn_style ${
							myLocation === ele.id ? "toggleActive" : "toggleInActive"
						}`}
						onClick={() => setLocation(ele.id)}
					>
						{ele.text}
					</div>
				))}

				{myLocation === "1" && (
					<div>
						<div className="card_style">
							<IonLabel className="select_address">Select Addresses</IonLabel>
							<IonLabel className="primary_bold_text">Pickup Location</IonLabel>
							<IonRadioGroup className="radio-group column_dir">
								{[
									{
										label: `${
											!!default_add.length ? default_add[0].addressType : "Default"
										}`,
										text: !default_add.length ? "Select from MAP" : HomeAdd(),
										key: "pick_default",
									},
									{
										label: "OTHERS",
										text: "Select from MAP",
										key: "pick_select",
									},
								].map((ele: any, index: number) => (
									<IonItem
										lines={"none"}
										className="radio_margin"
										key={index}
										onClick={
											ele.text === constants.SELECT_FROM_MAP
												? () => handleMapOpen(ele.key)
												: () => {}
										}
									>
										<IonRadio
											slot="start"
											value={ele.key}
											color={"primary"}
											onClick={() => setPickup(ele.key)}
											className="mg_0"
											mode="md"
										/>
										<div className="radio_label_space align_center">
											<div className="confirm_radio_label">
												{ele.label && `${ele.label} : ${" "}`}
												<span
													className={
														(!pickOtherAdd.length && index % 2 === 1) ||
														!default_add.length
															? "confirm_radio_label_val select_map"
															: "confirm_radio_label_val "
													}
													// className="confirm_radio_label_val"
												>
													{index % 2 === 1 && pickOtherAdd.length
														? addressString(pickOtherAdd)
														: ele.text}
												</span>
											</div>
										</div>
									</IonItem>
								))}
							</IonRadioGroup>

							<IonLabel className="primary_bold_text margn-top-zero">
								Drop Location
							</IonLabel>
							<IonRadioGroup className="radio-group column_dir">
								{[
									{ text: "Same as Pickup Location", key: "drop_default" },
									{
										label: "OTHERS",
										text: "Select from MAP",
										key: "drop_select",
									},
								].map((ele: any, index: number) => (
									<IonItem
										lines={"none"}
										className="radio_margin"
										key={index}
										onClick={index % 2 === 1 ? () => handleMap(ele.key) : () => {}}
									>
										<IonRadio
											slot="start"
											value={ele.key}
											color={"primary"}
											onClick={() => setDropLoc(ele.key)}
											className="mg_0"
											mode="md"
										/>
										<div className="radio_label_space align_center">
											<div className="confirm_radio_label">
												{ele.label && `${ele.label} : ${" "}`}
												<span
													className={
														!other_add.length && index % 2 === 1
															? "confirm_radio_label_val select_map"
															: "confirm_radio_label_val "
													}
												>
													{index % 2 === 1 && other_add.length
														? addressString(other_add)
														: ele.text}
												</span>
											</div>
										</div>
									</IonItem>
								))}
							</IonRadioGroup>
						</div>

						<div className="card_style">
							<div className="pick_drop_optional" onClick={() => setAccordian(!show_acc)}>
								{constants.PICK_DROP}
								<span className="optional">{constants.OPTIONAL}</span>
							</div>
							{!!show_acc && (
								<IonTextarea
									className="text_area"
									placeholder="Enter Instructions here..."
									value={pickUpNotes.charAt(0).toUpperCase() + pickUpNotes.slice(1)}
									onIonChange={(e: any) => setPickUpNotes(e.detail.value!)}
								></IonTextarea>
							)}
						</div>
					</div>
				)}

				{myLocation !== "1" && (
					<div
						className="card_style width_100per"
						onClick={() => !user_add.length && !default_add.length && handleMap("client")}
					>
						<div className="myloc_cont">
							<IonLabel className="loc_label">
								{constants.MY_LOCATION}
								<IonLabel
									className={
										!user_add.length && !default_add.length
											? "confirm_radio_label_val select_map cursor_pointer_style"
											: "sel_loc"
									}
								>
									{!!user_add.length
										? DisplayName(user_add)
										: !!default_add.length
										? default_add[0].addressType
										: " Select from MAP"}
								</IonLabel>
							</IonLabel>
							{/* {(!!user_add.length || !!default_add.length) && (
								<div
									className="change_text"
									onClick={() => {
										if (
											props.globalSettings.length &&
											props.globalSettings[0].workshopListingModel !== "Segment"
										) {
											setChangeAddress(true);
										} else {
											handleMap("client");
										}
									}}
								>
									{constants.CHANGE}
								</div>
							)} */}
						</div>
						<IonLabel className="add_text">
							{!!user_add.length ? addressString(user_add) : HomeAdd()}
						</IonLabel>
					</div>
				)}

				{!!showAddModal && (
					<UserAddressModal
						{...props}
						confirm={true}
						showAddModal={showAddModal}
						closeAddModal={() => setShowAddModal(false)}
						openMapModal={() => setShowMap(true)}
						closeConfirmModal={() => props.closeModal()}
						onChangeAddress={(value: any) =>
							address_label === "drop_select"
								? setAddress(value)
								: address_label === "pick_select"
								? setPickOtherAdd(value)
								: address_label === "client"
								? setUserAddress(value)
								: null
						}
					/>
				)}

				<IonModal
					isOpen={showMap}
					backdropDismiss={true}
					onDidDismiss={() => setShowMap(false)}
					cssClass="confirm_picker-modal"
				>
					<div className="address-confirm">
						<AddNewAddress
							{...props}
							confirm={true}
							closeMapModal={() => setShowMap(false)}
							onChangeAddress={(value: any) =>
								address_label === "drop_select"
									? setAddress(value)
									: address_label === "pick_select"
									? setPickOtherAdd(value)
									: address_label === "client"
									? setUserAddress(value)
									: null
							}
						/>
					</div>
				</IonModal>
				{/* {myLocation === "1" && ( */}
				<div
					className="card_style width_100per"
					onClick={() => setShowCalendar(!showCalendar)}
					//className="picker_div" // if date val  is not selected
				>
					<IonRow className="space_between cursor_pointer_style">
						<IonRow>
							<img src="/images/orange_cal.svg" />
							{moment(new Date(date)).format("DD MMMM YYYY") !==
								moment(new Date()).format("DD MMM YYYY") && !!slot ? (
								<IonLabel className="picker_text">
									{moment(new Date(date)).format("DD MMMM YYYY")}, {slot}
								</IonLabel>
							) : (
								<IonLabel className="picker_text">{constants.PICK_DATE}</IonLabel>
							)}
						</IonRow>
						{!slot && <img src="/images/add_symbol.svg" />}
					</IonRow>
				</div>
				{/* )} */}
				<IonModal
					isOpen={showCalendar}
					backdropDismiss={true}
					onDidDismiss={() => {
						setShowCalendar(false);
					}}
					cssClass="picker-modal"
				>
					<div className="picker-header">
						<IonLabel className="picker-header-year">
							{new Date(date).getFullYear()}
						</IonLabel>
						<div className="picker-header-month-date-div">
							<IonLabel className="picker-header-month-date">
								{`${days[new Date(date).getDay()]}`}
								{", "}
							</IonLabel>
							<IonLabel className="picker-header-month-date">
								{`${new Date(date).getDate()}`}{" "}
							</IonLabel>
							<IonLabel className="picker-header-month-date">
								{months[new Date(date).getMonth()]}
							</IonLabel>
						</div>
					</div>
					<Calendar
						onChange={(date: any) => changeDate(date)}
						// value={new Date(date)}
						value={dateSelected ? new Date(dateTemp) : null}
						minDate={new Date(props.firstAvailable)}
						maxDate={new Date(props.lastAvailable)}
						// defaultActiveStartDate={!!date ? new Date(date) : new Date()}
						defaultActiveStartDate={!!date ? new Date(dateTemp) : new Date()}
					/>
					<div className="picker-actions-div">
						<IonButton
							onClick={() => {
								// setDate(new Date());
								setDateTemp(new Date());
								setShowCalendar(!showCalendar);
							}}
							color="light"
							className="picker-action-buttons"
						>
							{constants.CANCEL}
						</IonButton>
						<IonButton
							color="light"
							className="picker-action-buttons"
							// onClick={() => {
							//   setShowCalendar(!showCalendar);
							//   if (
							//     date >= new Date(props.firstAvailable) &&
							//     date <= new Date(props.lastAvailable) &&
							//     !!props.time_slots &&
							//     props.time_slots.length > 0
							//   ) {
							//     setShowSlotModal(true);
							//   }
							// }}
							onClick={() => {
								// showTimeSlotPopup();
								setShowCalendar(!showCalendar);
								if (
									dateTemp >= new Date(props.firstAvailable) &&
									dateTemp <= new Date(props.lastAvailable) &&
									!!time_arr &&
									time_arr.length > 0
									// !!props.time_slots &&
									// props.time_slots.length > 0
								) {
									setShowSlotModal(true);
								} else {
									setToast({
										showToast: true,
										toastMessage: "No time slot is available",
										severity: "danger",
									});
								}
							}}
						>
							{constants.OK}
						</IonButton>
					</div>
				</IonModal>

				<IonModal isOpen={showSlotModal} backdropDismiss={false} cssClass="slot-modal">
					<div>
						<div className="slot_header">
							<IonLabel className="slot_heading">Choose a time slot</IonLabel>
						</div>
						<div
							className={
								time_arr.length > 7
									? "slot_container"
									: time_arr.length > 6
									? "slot_container_6"
									: time_arr.length > 5
									? "slot_container_small"
									: time_arr.length > 3
									? "slot_container_xxsmall"
									: "slot_container_xxsmall"
							}
						>
							{/* {props.time_slots.map((ele: any, ind: number) => ( */}
							{time_arr.map((ele: any, ind: number) => (
								<div
									key={ind}
									onClick={() => changeTimeSlot(`${ele.startTime}-${ele.endTime}`)}
									className={
										slotTemp === `${ele.startTime}-${ele.endTime}`
											? "active_slot"
											: "slot_val"
									}
								>
									{ele.startTime}-{ele.endTime}
								</div>
							))}
						</div>
					</div>
					<div className="picker-actions-div">
						<IonButton
							onClick={() => {
								setTimeSlot("");
								setShowSlotModal(!showSlotModal);
							}}
							color="light"
							className="picker-action-buttons"
						>
							{constants.CANCEL}
						</IonButton>
						<IonButton
							color="light"
							className="picker-action-buttons"
							onClick={(slot: any) => {
								setDate(dateTemp);
								setTimeSlot(slotTemp);
								setShowSlotModal(!showSlotModal);
							}}
						>
							{constants.OK}
						</IonButton>
					</div>
				</IonModal>

				<div className="card_style">
					<div
						className="pick_drop_optional"
						onClick={() => setServiceAccordian(!show_service_acc)}
					>
						{constants.SERVICE_NOTES}
						<span className="optional">{constants.OPTIONAL}</span>
					</div>
					{!!show_service_acc && (
						<IonTextarea
							className="text_area"
							placeholder="Enter text here..."
							value={serviceNotes.charAt(0).toUpperCase() + serviceNotes.slice(1)}
							onIonChange={(e: any) => setServiceNotes(e.detail.value!)}
						></IonTextarea>
					)}
				</div>

				<div className="card_style width_100per" style={{ marginTop: 0 }}>
					<IonRow
						className="space_between cursor_pointer_style confirm-position-relative"
						onClick={(event: any) => {
							if (
								(isPlatform("mobile") || isPlatform("mobileweb")) &&
								!props.confirmationImages.length
							) {
								return AccessNativeCamera();
							}
						}}
					>
						<IonRow>
							<img src="/images/add_img.svg" />
							<IonLabel className="picker_text">
								{constants.ADD_IMAGES}
								<span className="optional">{constants.OPTIONAL}</span>
							</IonLabel>
						</IonRow>
						{!props.confirmationImages.length && <img src="/images/add_symbol.svg" />}
						{!props.confirmationImages.length &&
							(isPlatform("desktop") || isPlatform("mobileweb")) && (
								<input
									type="file"
									className="input_type_file_cart_image"
									accept=".png , .jpg, .jpeg"
									onChange={(event) => {
										uploadImage(event);
									}}
								/>
							)}
					</IonRow>
					<div className="img_container">
						{/* {props.confirmationImages.map((img: any, index: any) => ( */}
						{allImages.map((img: any, index: any) => (
							<div
								className="upload-rc-documents"
								key={index}
								style={{
									position: "relative",
									height: 80,
									width: 80,
									marginRight: 10,
									borderRadius: 10,
									marginTop: 15,
								}}
							>
								<img
									src={img}
									alt={""}
									style={{
										height: "100%",
									}}
								/>
								{/* <CustomIonImage imgpath={img} key={img} /> */}
								<IonImg
									style={{
										position: "absolute",
										top: 0,
										right: 0,
										cursor: "pointer",
									}}
									src={"/images/close-icon.svg"}
									className="document-remove-icon"
									onClick={() => {
										deleteImage(img);
									}}
								/>
							</div>
						))}
						{!!props.confirmationImages.length && (
							<div
								style={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									height: 80,
									width: 80,
									backgroundColor: "white",
									borderRadius: 10,
									border: "1px solid #999999",
									marginTop: 15,
									position: "relative",
								}}
								onClick={(event: any) => {
									if (isPlatform("mobile") || isPlatform("mobileweb")) {
										return AccessNativeCamera();
									}
								}}
							>
								<IonImg src={"/images/add.svg"} style={{ height: 34, width: 34 }} />
								{(isPlatform("desktop") || isPlatform("mobileweb")) && (
									<input
										type="file"
										className="input_type_file_cart_image"
										accept=".png , .jpg, .jpeg"
										onChange={(event) => {
											uploadImage(event);
										}}
									/>
								)}
							</div>
						)}
					</div>
				</div>

				{Boolean(Object.keys(props.cart_estimates).length) && (
					<div className="card_style width_100per last_ele">
						<IonLabel className="select_address">
							{constants.BILL_DETAILS}{" "}
							<span className="servicesText">
								({props.service_data.length}
								{checkForPlural(props.service_data.length, constants.TWO_SERVICES)})
							</span>
						</IonLabel>
						<div className="align_center space_between">
							<IonLabel className="bill_label">
								{constants.SERVICE_TOTAL} ({constants.EXCL_TAXES})
							</IonLabel>
							<IonLabel className="bill_value">
								{constants.RupeeSymbol} {props.cart_estimates.totalEstimated}
							</IonLabel>
						</div>
						<div className="align_center space_between">
							<IonLabel className="bill_label">{constants.COUPON_DISCOUNT}</IonLabel>
							{!!props.offer_code ? (
								<IonLabel className="optional bill_discount">
									{`-`} {constants.RupeeSymbol} ${props.cart_estimates.discount}
								</IonLabel>
							) : (
								<IonLabel className="optional bill_discount">
									{constants.RupeeSymbol} {0}
								</IonLabel>
								// <IonLabel className="optional bill_discount">₹ {0}</IonLabel>
							)}
						</div>
						<div className="align_center space_between">
							<IonLabel className="bill_label">{constants.TOTAL_ESTIMATED}</IonLabel>
							<IonLabel className="bill_value">
								{constants.RupeeSymbol}{" "}
								{Number(props.cart_estimates.totalEstimated) -
									Number(props.cart_estimates.discount)}
							</IonLabel>
						</div>
					</div>
				)}
			</div>

			{/* <IonRow className="pick_error_div">
      <IonImg src="/images/error_icon.svg"/>
      <IonLabel className="picker_error">{constants.PICKER_ERROR}</IonLabel>
    </IonRow> */}

			<div
				className="confirm_page-footer"
				style={isPlatform("mobileweb") ? { bottom: 55 } : {}}
			>
				{!!props.settings.pricingSegment && (
					<div className="sd_show_pricing">
						<IonLabel className="sd_pricing_text">
							{`${constants.PRICE_BASED_ON} ${
								props.settings.pricingSegment.charAt(0).toUpperCase() +
								props.settings.pricingSegment.slice(1)
							} ${constants.PRICING}`}
						</IonLabel>
					</div>
				)}
				<div className="sd_show_cost confirm_btn_bottom">
					<div className="sd_col">
						{/* <IonLabel className="sd_escost">{constants.ADVANCE_PAYMENT}</IonLabel>
            <IonLabel className="pay_value">
              {constants.RupeeSymbol} {props.cart_estimates.advancePayment}
            </IonLabel> */}
					</div>
					<IonButton
						color="light"
						className="service-details-continue-button"
						onClick={() => {
							handlePaynow();
						}}
					>
						<IonLabel color="primary">
							{Number(props.cart_estimates.advancePayment) > 0 ? `Book Now` : `Book Now`}
						</IonLabel>
					</IonButton>
				</div>
			</div>
			<ToastMessage
				showToast={toast.showToast}
				ToastMessage={toast.toastMessage}
				severity={toast.severity}
				onDidDismiss={() => {
					setToast({
						showToast: false,
						toastMessage: "",
						severity: "",
					});
				}}
			/>
			<IonModal
				isOpen={login}
				backdropDismiss={true}
				onDidDismiss={() => setLogin(false)}
				cssClass="confirmModal"
				animated={checkMediaQuery() ? false : true}
				enterAnimation={enterAnimation}
				leaveAnimation={leaveAnimation}
			>
				{!showOtp ? (
					<LoginInCart
						{...props}
						showOtp={() => setShowOtp(true)}
						setLogin={() => setLogin(false)}
					/>
				) : (
					<OtpInCart {...props} setLogin={() => setLogin(false)} />
				)}
			</IonModal>
			<AlertMessage
				showAlert={changeAddress}
				alertMessage={
					"Are you sure you want to change the address? current services added to cart will be lost"
				}
				onDidDismiss={() => {
					setChangeAddress(false);
				}}
				alertHeader={"Change address"}
				actionItemForAlert={async () => {
					await props.deleteCartItemList();
					await props.closeModal();
				}}
				cssClass={"alert-message"}
			/>
		</IonCol>
	);
};
export default connect(
	({
		auth: {
			defaultAddressRef,
			selectedVehicleRef,
			settings,
			primaryPhoneNumber,
			email,
			name,
		},
		booking: { confirmationImages },
		cart: {
			dates,
			firstAvailable,
			lastAvailable,
			time_slots,
			booking_image,
			cart_items,
			cart_estimates,
			service_data,
		},
		userInfo: {
			userAddress,
			searchRecommendations,
			userVehiclesList,
			carSlidesData,
			sliderCatelogVehicleId,
			userAddressList,
			selectedAddressRef,
		},
		workshop: { globalSettings },
	}: any) => ({
		settings,
		dates,
		time_slots,
		firstAvailable,
		lastAvailable,
		cart_items,
		cart_estimates,
		service_data,
		defaultAddressRef,
		selectedVehicleRef,

		// userAddress,
		searchRecommendations,
		userVehiclesList,
		// carSlidesData,
		sliderCatelogVehicleId,
		userAddressList,
		selectedAddressRef,
		confirmationImages,
		primaryPhoneNumber,
		email,
		name,
		globalSettings,
	}),
	{
		getTimeSlots,
		saveBookingTransaction,
		saveReservations,
		updateOnBoarding,
		signIn,
		modifyToken,
		uploadBookingImage,
		deletePrebookingImage,
		savePrebookingImage,
		// saveVehicleBookingImage,
		saveLocationPermissionStatus,
		// razorpayCallBack,
		getCartItemsList,
		saveBookingDetailsHeaderStatus,
	}
)(ConfirmScreen);
